var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3093 48.2947L12.9971 41.022L4.79047 39.2531L5.59518 30.7875L0.0610352 24.4486L5.59518 18.1098L4.79047 9.64421L12.9971 7.87527L17.3093 0.602539L24.9999 3.85173L32.6905 0.602539L37.0027 7.87527L45.2093 9.64421L44.4046 18.1098L49.9387 24.4486L44.4046 30.7875L45.2093 39.2531L37.0027 41.022L32.6905 48.2947L24.9999 45.0456L17.3093 48.2947ZM18.4124 44.9861L24.9999 42.2439L31.6171 44.9861L35.3332 38.7861L42.4374 37.2064L41.7916 29.8736L46.5707 24.4486L41.7916 18.9939L42.4374 11.6611L35.3332 10.1111L31.5874 3.91114L24.9999 6.65335L18.3827 3.91114L14.6666 10.1111L7.56239 11.6611L8.20822 18.9939L3.42906 24.4486L8.20822 29.8736L7.56239 37.2361L14.6666 38.7861L18.4124 44.9861ZM22.2874 31.8312L35.0949 19.0236L33.2666 17.1656L22.2874 28.1447L16.7332 22.6203L14.9049 24.4486L22.2874 31.8312Z",
    fill: "#55C880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.22c7ef9f53b569567356ce77b94f6f4d.svg";
export { ForwardRef as ReactComponent };